import {
  Globe,
  Compass,
  Sliders,
  ShieldCheck,
  CheckCircle2,
  Headphones,
  TrendingUp,
  Building2,
  BarChart3,
  Users2,
  Briefcase,
  Target,
} from "lucide-react";

export const COMPANY_HERO_STATS = [
  { value: "50+", label: "Industry Verticals Covered", icon: Briefcase },
  { value: "170+", label: "Countries Mapped", icon: Globe },
  { value: "7-Step", label: "Proprietary AI & Human QA", icon: ShieldCheck },
  { value: "4x", label: "Target Sales Velocity", icon: TrendingUp },
];

export const CORE_STRATEGY_POINTS = [
  {
    icon: Building2,
    title: "Competitor & Market Analysis",
    desc: "Evaluate competitor performance, industry benchmarks, and market shifts with structured firmographic insights.",
  },
  {
    icon: BarChart3,
    title: "Actionable High-Quality Signals",
    desc: "Negligible bounce rates backed by continuous data scientist reviews so funds aren't wasted on dead corporate domains.",
  },
  {
    icon: Target,
    title: "High Profit Margin Sourcing",
    desc: "Discover emerging investment and expansion opportunities to target enterprise accounts primed to scale.",
  },
];

export const EMAIL_LIST_ADVANTAGES = [
  {
    icon: Sliders,
    title: "Segmented E-Mail List",
    desc: "Granular firmographic segmentation for maximum campaign accessibility and persona resonance.",
  },
  {
    icon: Compass,
    title: "Global Geo-Targeted Prospects",
    desc: "Connect seamlessly with verified organizations situated in exact operational territories worldwide.",
  },
  {
    icon: Users2,
    title: "Custom Personalization",
    desc: "Mailing databases formatted with dynamic fields ready for 1-to-1 account-based sales cadences.",
  },
  {
    icon: ShieldCheck,
    title: "7-Step Rigorous Verification",
    desc: "Multi-layered algorithmic validation combined with manual audits ensures top-tier deliverability.",
  },
  {
    icon: CheckCircle2,
    title: "Strict Policy & Spam Compliance",
    desc: "Consent-aware datasets compiled to minimize spam traps and safeguard domain sender rep.",
  },
  {
    icon: Headphones,
    title: "Optimum Post-Sales Assistance",
    desc: "Dedicated account support to help calibrate your queries, verify entries, and replenish bounces.",
  },
];

export const CAMPAIGN_WORKFLOW = [
  {
    step: "01",
    title: "Connect with Representatives",
    desc: "Link with our sales specialists and submit your criteria for targeted business accounts and specific company profiles.",
  },
  {
    step: "02",
    title: "Precision Curation & QA",
    desc: "Our data team initiates the 7-step review cycle and delivers your verified custom company database within 6–9 business days.",
  },
  {
    step: "03",
    title: "Deploy Intent-Based Outbound",
    desc: "Use your intent-informed mailing list to execute personalized, multi-channel email campaigns directly to key buying groups.",
  },
  {
    step: "04",
    title: "Quadruple Conversions & Sales",
    desc: "Accelerate customer loyalty and overall revenue through elevated brand engagement, inbox deliverability, and account visibility.",
  },
];